








































import Vue from 'vue';
import Fleet from '@/classes/fleet/fleet';
import ContactRates from '@/components/result/ContactRates.vue';
import AntiAirCalculator from '@/components/result/AntiAirCalculator.vue';
import AntiSubmarineSupport from '@/components/result/AntiSubmarineSupport.vue';

export default Vue.extend({
  name: 'FleetDetail',
  components: {
    AntiSubmarineSupport,
    AntiAirCalculator,
    ContactRates,
  },
  props: {
    fleet: {
      type: Fleet,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    isUnion: {
      type: Boolean,
      default: false,
    },
    handleClose: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    tab: 'stage2',
  }),
  mounted() {
    const contact = this.$refs.contactRates as InstanceType<typeof ContactRates>;
    if (contact) {
      contact.calculate();
    }
    const antiAirCalculator = this.$refs.antiAirCalculator as InstanceType<typeof AntiAirCalculator>;
    if (antiAirCalculator) {
      antiAirCalculator.updateTable();
    }
  },
  methods: {
    close() {
      this.handleClose();
    },
  },
});
